import { render } from "./RecordList.vue?vue&type=template&id=f9842dde&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"

import "./RecordList.vue?vue&type=style&index=0&id=f9842dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9842dde"]])

export default __exports__